module.exports = __webpack_public_path__ + "static/media/wordmark.6d2d2c86.svg";